import search from './search';

export default {
  cat4mro: {
    pages: {
      ...search,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/cat4mro/index.js